import { cn } from '@/lib/utils';
import topoBackground from '../../../assets/expedition-topo-bg.png';

interface GuidedStudyLoadingSkeletonProps {
    isDarkMode: boolean;
}

export function GuidedStudyLoadingSkeleton({ isDarkMode }: GuidedStudyLoadingSkeletonProps) {
    return (
        <div className={cn(
            "relative w-full overflow-hidden min-h-[320px] transition-all duration-500",
            isDarkMode ? "bg-[#0a0a0b] text-slate-200" : "bg-[#fdfbf7] text-slate-800"
        )}>
            {/* Expedition Background Visual */}
            <div className={`absolute inset-0 z-0 pointer-events-none overflow-hidden ${isDarkMode ? 'opacity-40' : 'opacity-40'}`}>
                <img
                    src={topoBackground}
                    alt=""
                    className={`w-full h-full object-cover scale-110 transition-opacity duration-1000 ${isDarkMode ? 'brightness-[1.8] saturate-[1.2] mix-blend-screen' : 'brightness-95 saturate-[0.8] mix-blend-multiply'} `}
                />
                <div className={`absolute inset-0 ${isDarkMode
                    ? 'bg-gradient-to-b from-[#0a0a0b] via-transparent to-[#0a0a0b]'
                    : 'bg-gradient-to-b from-[#fdfbf7] via-transparent to-[#fdfbf7]'
                    } `}
                />
                {/* Subtle Map Texture Overlay */}
                <div className={`absolute inset-0 pointer-events-none ${isDarkMode ? 'opacity-[0.03] invert' : 'opacity-[0.03]'}`} style={{ backgroundImage: 'url("https://www.transparenttextures.com/patterns/parchment.png")' }} />
            </div>
            <div className="container mx-auto px-4 py-8 max-w-4xl space-y-8 animate-pulse">
                <div className="flex justify-between items-center">
                    <div className="h-8 w-48 bg-muted rounded-lg" />
                    <div className="h-6 w-6 bg-muted rounded-full" />
                </div>
                <div className="space-y-4">
                    <div className="h-4 w-full bg-muted rounded" />
                    <div className="h-4 w-3/4 bg-muted rounded" />
                </div>
                <div className="h-32 w-full bg-muted rounded-xl" />
            </div>
        </div>
    );
}
